const dataFeatured = [
  {
    id: "1",
    img: "/images/s-1.webp",
    alt: "Hollister-V-Neck Knit",
    text: "rexpo-Hollister V-Neck Knit",
    price: 88000,
    brand: "rexpo",
  },
  {
    id: "2",
    img: "/images/s-2.webp",
    alt: "Rexpo-Womens-shoes",
    text: "quickiin Womens shoes",
    price: 600000,
    brand: "quickiin",
  },
  {
    id: "3",
    img: "/images/s-3.webp",
    alt: "Quickiin-Mens-shoes",
    text: "nike Mens shoes",
    price: 14000,
    brand: "nike",
  },
  {
    id: "4",
    img: "/images/s-4.webp",
    alt: "Leather Mens Slipper",
    text: "rexpo-Leather Mens Slipper",
    price: 100000,
    brand: "rexpo",
  },
  {
    id: "5",
    img: "/images/s-5.webp",
    alt: "New Womens High Hills",
    text: "quickiin-New Womens High Hills",
    price: 3000,
    brand: "quickiin",
  },
  {
    id: "6",
    img: "/images/s-6.webp",
    alt: "Primitive Mens shoes",
    text: "nike-Primitive Mens shoes",
    price: 50000,
    brand: "nike",
  },
];

export default dataFeatured;
